import TBCH from "../static/tbch logo.png";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function Homepage() {
  const [sidebar, setSidebar] = useState(false);
  const [logIn, setLogIn] = useState({
    isLoggedIn: false,
    userInfo: {
      name: "",
      id: "",
    },
  });

  const clearLocalStorage = () => {
    setLogIn({ ...logIn, isLoggedIn: false, userInfo: { name: "", id: "" } });
    return localStorage.removeItem("current-user");
  };

  useEffect(() => {
    document.title = "TBCH (To Be Completely Honest)";
    axios
      .post(
        "/_tbch-api/verify",
        {},
        {
          headers: {
            "auth-token": localStorage.getItem("current-user") || "",
          },
        }
      )
      .then((d) => {
        d.data
          ? setLogIn({
              ...logIn,
              isLoggedIn: true,
              userInfo: { name: d.data.name, id: d.data._id },
            })
          : clearLocalStorage();
      })
      .catch((e) => {
        alert("Can't connect to server.");
      });
  }, []);

  const handleLogout = () => {
    localStorage.clear("current-user");
    return window.location.reload();
  };

  const sideBar = () => {
    if (sidebar) {
      return setSidebar(false);
    } else {
      return setSidebar(true);
    }
  };

  return (
    <div className="main">
      {!logIn.isLoggedIn ? (
        <nav
          className="mobile-nav"
          style={
            sidebar
              ? { transform: "translateX(0%)" }
              : { transform: "translateX(100%)" }
          }
        >
          <div className="close-button-wrap">
            <i class="lni lni-cross-circle" onClick={sideBar}></i>
          </div>
          <div className="choices">
            <span>
              <Link to="/login">Log In</Link>
            </span>
            <span>
              <Link to="/register">Register</Link>
            </span>
          </div>
          <img src={TBCH} alt="" />
          <div className="mark">
            <span>@ctxsoftwaresphilippines</span>
            <span>@charliecatxph</span>
            <span>Designed and developed by : Charl Concepcion, CEO of CTX Softwares Philippines</span>
          </div>
        </nav>
      ) : (
        <nav
          className="mobile-nav"
          style={
            sidebar
              ? { transform: "translateX(0%)" }
              : { transform: "translateX(100%)" }
          }
        >
          <div className="close-button-wrap">
            <i class="lni lni-cross-circle" onClick={sideBar}></i>
          </div>
          <div className="choices">
            <span>
              <Link to="/dashboard">Dashboard</Link>
            </span>
            <span onClick={handleLogout}>
              <Link to="/">Log Out</Link>
            </span>
          </div>
          <img src={TBCH} alt="" />
          <div className="mark">
          <span>@ctxsoftwaresphilippines</span>
          <span>@charliecatxph</span>
          <span>
            Designed and developed by : Charl Concepcion, CEO of CTX Softwares
            Philippines
          </span>
        </div>
        </nav>
      )}
      <section className="landing-page bg-src">
        <div className="darken"></div>
        <nav className="nav-bar">
          <div className="container">
            <div className="logo">
              <img src={TBCH} alt="" />
            </div>
            {logIn.isLoggedIn ? (
              <>
                <div className="profile">
                  <span onClick={handleLogout}>Log Out</span>
                </div>
                <div className="burger-menu-btn" onClick={sideBar}>
                  <i class="lni lni-menu"></i>
                </div>
              </>
            ) : (
              <>
                <div className="navbar-buttons">
                  <div className="button">
                    <span>
                      <Link to="/login">Log In</Link>
                    </span>
                  </div>
                  <div className="button">
                    <span>
                      <Link to="/register">Register</Link>
                    </span>
                  </div>
                </div>
                <div className="burger-menu-btn" onClick={sideBar}>
                  <i class="lni lni-menu"></i>
                </div>
              </>
            )}
          </div>
        </nav>
        <div className="container">
          <div className="wrap-landing-text">
            {!logIn.isLoggedIn ? (
              <>
                <span class="tbch-logo">👀</span>
                <span class="tbch-head">To Be Completely Honest.</span>
                <span>Send secret messages, anonymously.</span>
                <span class="ctx-logo">&lt;charliecatxph/&gt;</span>
              </>
            ) : (
              <>
                <span class="tbch-logo">👀</span>
                <span class="tbch-head">
                  Welcome to TBCH, {logIn.userInfo.name}.
                </span>
                <span class="ctx-logo">&lt;charliecatxph/&gt;</span>
                <button class="homepage-btn">
                  <Link to="/dashboard">Go to dashboard</Link>
                </button>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
